import React from 'react';
import { useSelector } from 'react-redux';

import Icon from '../../../../icons/Icon';
import { ICONS } from '../../../../icons';
import ConsumerHeader from '../../../consumer-header/ConsumerHeader';

import scss from './Header.module.scss';

function Header() {
  const projectName = useSelector((state) => state.genie.projectName);

  return (
    <ConsumerHeader>
      <div className={scss.projectName}>
        <Icon icon={ICONS.Genie} />
        <h3>{projectName}</h3>
      </div>
    </ConsumerHeader>
  );
}

export default Header;
